const initialState = { supplements: null, returnProducts: null };

const supplementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_SUPPLEMENTS": {

      return {
        ...state,
        supplements: action.data,
      };
    }
    case "FETCH_PRODUCT_RETURNS": {

      return {
        ...state,
        returnProducts: action.data,
      };
    }

    case "CREATE_SUPPLEMENT": {
      let dt = state.supplements.concat(action.data);
      return {
        ...state,
        supplements: dt,
      };
    }
    case "CREATE_PRODUCT_RETURNS": {
      let dt = state.returnProducts.concat(action.data);
      return {
        ...state,
        returnProducts: dt,
      };
    }
    case "UPDATE_SUPPLEMENT": {
      let dt = state.supplements.map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        supplements: dt,
      }
    };
    case "DELETE_SUPPLEMENT": {
      let dt = state.supplements.filter((order) => {
        if (order._id !== action.data) {
          return order;
        }
      });
      return {
        ...state,
        supplements: dt,
      }
    };
    default:
      return state;
  }
};

export default supplementsReducer;
